// 快訊分享元件
"use client";
import { useState, useEffect } from "react";
import Image from "next/image";
import useCopy from "@/hook/useCopy";

const ShareComponent = ({ location = null }) => {
  const copy = useCopy();
  const [currentPath, setCurrentPath] = useState("");

  useEffect(() => {
    if (typeof window !== "undefined") {
      // 获取当前页面的完整路径
      const path = window.location.href;
      setCurrentPath(path);
    }
  }, []);

  if (location === "flash") {
    return (
      <div className="absolute left-[18px] ulg:hidden top-0 h-full">
        <div
          className="sticky top-[50%] translate-y-[-50%] z-[2] flex flex-col [&>*]:img-box [&>*]:w-[35px] [&>*]:h-[35px]
      gap-y-[16px] [&>*]:after:content-[none] [&>*]:trans [&>*]:ulg:!translate-x-0 uxl:hidden"
        >
          <a
            href={`https://www.facebook.com/sharer/sharer.php?u=${currentPath}`}
            target="_blank"
            rel="noreferrer noopener"
            className="hover:translate-x-[4px]"
          >
            <Image
              className="dark:hidden"
              width={35}
              height={35}
              src="/images/column/icon_facebook.svg"
              alt="facebook_share"
              loading="lazy"
            />
            <Image
              className="hidden dark:inline-block"
              width={35}
              height={35}
              src="/images/column/icon_dark_facebook.svg"
              alt="facebook_share"
              loading="lazy"
            />
          </a>

          <a
            href={`https://telegram.me/share/url?url=${currentPath}`}
            target="_blank"
            rel="noreferrer noopener"
            className="hover:translate-x-[4px]"
          >
            <Image
              className="dark:hidden"
              width={35}
              height={35}
              src="/images/column/icon_telegram.svg"
              alt="telegram_share"
              loading="lazy"
            />
            <Image
              className="hidden dark:inline-block"
              width={35}
              height={35}
              src="/images/column/icon_dark_telegram.svg"
              alt="telegram_link"
              loading="lazy"
            />
          </a>

          <a
            href={`http://twitter.com/share?url=${currentPath}`}
            target="_blank"
            rel="noreferrer noopener"
            className="hover:translate-x-[4px]"
          >
            <Image
              className="dark:hidden"
              width={35}
              height={35}
              src="/images/column/icon_twitter.svg"
              alt="twitter_share"
              loading="lazy"
            />
            <Image
              className="hidden dark:inline-block"
              width={35}
              height={35}
              src="/images/column/icon_dark_twitter.svg"
              alt="share_twitter"
              loading="lazy"
            />
          </a>

          <a
            href={`https://social-plugins.line.me/lineit/share?url=${currentPath}`}
            target="_blank"
            rel="noreferrer noopener"
            className="hover:translate-x-[4px]"
          >
            <Image
              className="dark:hidden"
              width={35}
              height={35}
              src="/images/column/icon_line.svg"
              alt="line_share"
              loading="lazy"
            />
            <Image
              className="hidden dark:inline-block"
              width={35}
              height={35}
              src="/images/column/icon_dark_line.svg"
              alt="share_line"
              loading="lazy"
            />
          </a>

          <button
            onClick={() => copy(currentPath)}
            className="hover:translate-x-[4px]"
          >
            <Image
              className="dark:hidden"
              width={35}
              height={35}
              src="/images/icon/icon_share.svg"
              alt="share_link"
              loading="lazy"
            />
            <Image
              className="hidden dark:inline-block"
              width={35}
              height={35}
              src="/images/column/icon_dark_copy.svg"
              alt="share_link"
              loading="lazy"
            />
          </button>
        </div>
      </div>
    );
  }

  return (
    <div
      className="fixed left-[18px] top-[50%] translate-y-[-50%] z-[2] flex flex-col [&>*]:img-box [&>*]:w-[35px] [&>*]:h-[35px] gap-y-[16px] [&>*]:after:content-[none] [&>*]:trans
    [&>*]:ulg:!translate-x-0 uxl:hidden dark:[&>*]:invert-[100%]"
    >
      <a
        href={`https://www.facebook.com/sharer/sharer.php?u=${currentPath}`}
        target="_blank"
        rel="noreferrer noopener"
        className="hover:translate-x-[4px]"
      >
        <Image
          className="dark:hidden"
          width={35}
          height={35}
          src="/images/column/icon_facebook.svg"
          alt="facebook_share"
          loading="lazy"
        />
        <Image
          className="hidden dark:inline-block"
          width={35}
          height={35}
          src="/images/column/icon_dark_facebook.svg"
          alt="facebook_share"
          loading="lazy"
        />
      </a>

      <a
        href={`https://telegram.me/share/url?url=${currentPath}`}
        target="_blank"
        rel="noreferrer noopener"
        className="hover:translate-x-[4px]"
      >
        <Image
          className="dark:hidden"
          width={35}
          height={35}
          src="/images/column/icon_telegram.svg"
          alt="telegram_share"
          loading="lazy"
        />
        <Image
          className="hidden dark:inline-block"
          width={35}
          height={35}
          src="/images/column/icon_dark_telegram.svg"
          alt="telegram_link"
          loading="lazy"
        />
      </a>

      <a
        href={`http://twitter.com/share?url=${currentPath}`}
        target="_blank"
        rel="noreferrer noopener"
        className="hover:translate-x-[4px]"
      >
        <Image
          className="dark:hidden"
          width={35}
          height={35}
          src="/images/column/icon_twitter.svg"
          alt="twitter_share"
          loading="lazy"
        />
        <Image
          className="hidden dark:inline-block"
          width={35}
          height={35}
          src="/images/column/icon_dark_twitter.svg"
          alt="share_twitter"
          loading="lazy"
        />
      </a>

      <a
        href={`https://social-plugins.line.me/lineit/share?url=${currentPath}`}
        target="_blank"
        rel="noreferrer noopener"
        className="hover:translate-x-[4px]"
      >
        <Image
          className="dark:hidden"
          width={35}
          height={35}
          src="/images/column/icon_line.svg"
          alt="line_share"
          loading="lazy"
        />
        <Image
          className="hidden dark:inline-block"
          width={35}
          height={35}
          src="/images/column/icon_dark_line.svg"
          alt="share_line"
          loading="lazy"
        />
      </a>

      <button
        onClick={() => copy(currentPath)}
        className="hover:translate-x-[4px]"
      >
        <Image
          className="dark:hidden"
          width={35}
          height={35}
          src="/images/icon/icon_share.svg"
          alt="share_link"
          loading="lazy"
        />
        <Image
          className="hidden dark:inline-block"
          width={35}
          height={35}
          src="/images/column/icon_dark_copy.svg"
          alt="share_link"
          loading="lazy"
        />
      </button>
    </div>
  );
};

export default ShareComponent;
